<template>
  <b-modal
    v-model="localIsActive"
    size="md"
    hide-footer
    no-close-on-esc
    no-close-on-backdrop
    @show="onShow"
    @hide="onHide"
  >
    <template #modal-title>
      <div class="text-white">
        Código de usuario
      </div>
    </template>
    <b-tabs
      v-model="tabIndex"
      class="my-2"
      align="center"
    >
      <b-tab title="Enviar enlace">
        <b-input-group v-if="codeEncryptedLink" class="mt-3">
          <template #append>
            <b-input-group-text>
              <div
                v-clipboard:copy="`${codeEncryptedLink}`"
                v-clipboard:success="onCopy"
                v-clipboard:error="onError"
                style="cursor: pointer"
              >
                <feather-icon icon="LinkIcon" size="16" class="align-middle text-body" />
              </div>
            </b-input-group-text>
          </template>
          <b-form-input v-model="codeEncryptedLink" />
        </b-input-group>
        <div v-else class="text-center mt-3">
          <b-button
            variant="success"
            @click="getEncriptedCode"
            :disabled="loading"
          >
            <span class="text-nowrap text-capitalize">
              {{ $t("users.generate_link") }}
            </span>
          </b-button>
        </div>
      </b-tab>
      <b-tab :title="`${$t('users.send_link_email')}`">
        <b-input-group class="mt-3">
          <b-form-input
            v-model="email"
            placeholder="Ingresa correo electronico"
            :disabled="loading"
          />
          <b-input-group-append>
            <b-button
              variant="primary"
              :disabled="sendByEmailDisabled"
              @click="sendByEmail()"
            >
              Enviar
            </b-button>
          </b-input-group-append>
        </b-input-group>
        <div v-if="errorEmail" class="invalid-feedback">
          {{ errorEmail }}
        </div>
      </b-tab>
    </b-tabs>
  </b-modal>
</template>

<script>
import axios from '@axios';
import { computed,ref } from '@vue/composition-api';
import { SLOT_TYPES } from "@/config/layoutConfig";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import { useToast } from "vue-toastification/composition";

export default {
  props: {
    user: {
      type: Object
    },
    showModalUserCode:{
      type: Boolean
    }
  },
  setup(props, { emit }) {
    //COMPOSABLES
    const toast = useToast();

    //DATA
    const codeEncrypted = ref(null);

    const codeEncryptedLink = ref(null);

    const email = ref(null);

    const errorEmail = ref(null);

    const loading = ref(false);

    const tabIndex = ref(0);

    //COMPUTED
    const sendByEmailDisabled = computed(() => (loading.value || !email.value));

    const localIsActive = computed({
      get() {
        return props.showModalUserCode;
      },
      set(value) {
        emit("update:isActive", value);
      },
    });

    //METHODS
    const getEncriptedCode = async () => {
      loading.value = true

      await axios.post('v1/dmp/capabilities/code-user-encrypt', { code: props.user.userCode })
        .then(response => {
          const { data } = response;

          codeEncrypted.value = data.data;
          codeEncryptedLink.value = `${window.location.origin}/#/dmp/user-code/${codeEncrypted.value}`;
        })
        .catch((error) => {
          const { message = 'Error al obtener el código' } = error.response.data;
        })
        .finally(() => {
          loading.value = false;
        });
    }

    const onCopy = () => {
      navigator.clipboard.writeText(codeEncryptedLink.value);

      toast({
        component: ToastificationContent,
        props: {
          title: 'Copiado correctamente',
          icon: 'ClipboardIcon',
          variant: 'success',
        },
      })
    }

    const onError = () => {
      toast({
        component: ToastificationContent,
        props: {
          title: 'No se pudo copiar',
          icon: 'AlertTriangleIcon',
          variant: 'danger',
        },
      })
    }

    const onHide = () => {
      codeEncrypted.value = null;
      codeEncryptedLink.value = null;
      tabIndex.value = 0;
      errorEmail.value = null;

      emit('update:isActive', false);
    }

    const onShow = async () => {

    }

    const sendByEmail = async () => {
      errorEmail.value = null;

      if (!email.value) {
        errorEmail.value = 'El correo electronico es requerido';
        return
      }

      const request = {
        email: email.value,
        code: props.user.userCode
      }

      loading.value = true;

      await axios.post('v1/dmp/capabilities/send-code-by-email', request)
        .then(response => {
          const { data } = response;

          toast({
            component: ToastificationContent,
            props: {
              title: data.message,
              icon: 'ClipboardIcon',
              variant: 'success',
            },
          });

          onHide();
        })
        .catch((error) => {
          toast({
            component: ToastificationContent,
            props: {
              title: error.response.data.message,
              icon: 'AlertTriangleIcon',
              variant: 'danger',
            },
          })
        })
        .finally(() => {
          loading.value = false;
        });
    }

    return {
      codeEncrypted,
      codeEncryptedLink,
      email,
      errorEmail,
      loading,
      tabIndex,

      sendByEmailDisabled,
      localIsActive,

      getEncriptedCode,
      onCopy,
      onError,
      onHide,
      onShow,
      sendByEmail
    }
  }
}
</script>

<style scoped>

</style>

